module.exports = __webpack_public_path__ + "media/images/splashscreen-mobile-app-70cf4509671fc071a9be9e3457b5bb8b.png";